import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { CapsulePin } from '../../types/capsule';

interface Props {
  capsule: CapsulePin;
}

function formatUnlockDate(ts: number): string {
  return new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function createCapsuleIcon(): L.DivIcon {
  return L.divIcon({
    className: '',
    html: `
      <div class="stabeon-capsule-marker">
        <div class="stabeon-capsule-pulse"></div>
        <div class="stabeon-capsule-inner">🔒</div>
      </div>
    `,
    iconSize: [36, 36],
    iconAnchor: [18, 18],
  });
}

export function CapsulePinMarker({ capsule }: Props) {
  const map = useMap();

  useEffect(() => {
    if (!capsule.lat || !capsule.lng) return;

    const icon = createCapsuleIcon();
    const marker = L.marker([capsule.lat, capsule.lng], { icon });

    const unlockLabel = formatUnlockDate(capsule.unlockAt);
    const isUnlocked = capsule.unlockAt <= Date.now();
    const popupContent = isUnlocked
      ? `<div style="font-size:13px;font-weight:600;color:#a78bfa;">✨ Ready to open!</div>`
      : `<div style="font-size:13px;font-weight:600;color:#a78bfa;">🔒 Opens ${unlockLabel}</div>`;

    marker.bindPopup(popupContent, {
      className: 'capsule-popup',
      closeButton: false,
      offset: [0, -12],
    });

    marker.on('click', () => {
      marker.openPopup();
    });

    marker.addTo(map);

    return () => {
      marker.remove();
    };
  }, [map, capsule]);

  return null;
}
